import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AuthenticationService } from 'src/app/_services/authentication.service';

@Component({
  selector: 'app-company-details',
  templateUrl: './company-details.component.html',
  styleUrls: ['./company-details.component.scss']
})
export class CompanyDetailsComponent implements OnInit {

  companyDetails: any;
  branches: any;
  companyId: any;
  branchEdit: any;
  loading: any;

  constructor(private route: ActivatedRoute, private authService: AuthenticationService) {
    this.companyId = this.route.snapshot.paramMap.get("id")
    
   }

  ngOnInit() {
    this.getCompanyDetails(this.companyId);
  }

  getCompanyDetails(id:any){
    this.loading = true;
    this.authService.getCompanyDetails(id).then(res => {
      console.log(res);
      this.companyDetails = res;
      this.getBranches(id);
    }, err => {
      console.log(err);
      this.loading = false;
    });
  }

  getBranches(id:any){
    let data = { id: id }
    this.authService.getBranches(data).then(res=>{
      this.branches = res;
      console.log(res);
      this.loading = false;
    }, err=>{
      console.log(err);
      this.loading = false;
    })
  }

  branchDetails(branch:any){
    this.branchEdit = branch;
  }

}
